import { CloseIcon } from 'assets/images/bussines';
import { FC, useState } from 'react';
import CreditDaysCounter from 'components/CreditDaysCounter/CreditDaysCounter';
import { displaySuccessNotification } from 'utils/displayNudosStandardNotifications';
import { formatShortDate } from 'utils/formatDatesAndHours';
import { NudosButton, NudosSelectButton } from 'components/NudosComponents';
import IconNudos from 'assets/images/header/iconNudos';
import './ModalUpdateCredit.scss';

interface IModalUpdateCredit {
  closeModal: () => void;
  organizationName: string;
  committedPaymentDate: string;
  newCommittedPaymentDate?: string | null;
  organizationCreditDays: number;
  onUpdateCreditDate: (sendNotificationEmail: boolean) => void;
  isUpdating?: boolean;
}

// Tipo que garantiza que al menos uno de los IDs esté presente
type ModalUpdateCreditProps = IModalUpdateCredit &
  ({ orderId: string; serviceId?: never } | { serviceId: string; orderId?: never });

const ModalUpdateCredit: FC<ModalUpdateCreditProps> = ({
  closeModal,
  organizationName,
  orderId,
  serviceId,
  committedPaymentDate,
  newCommittedPaymentDate,
  organizationCreditDays,
  onUpdateCreditDate,
  isUpdating = false
}) => {
  const [sendNotificationEmail, setSendNotificationEmail] = useState<boolean>(true);
  const getSubtitleText = () => {
    const subtitle = orderId
      ? `El nuevo plazo solo afectará a la orden N° ${orderId}`
      : `El nuevo plazo solo afectará al servicio N° ${serviceId}`;

    return subtitle;
  };

  const handleCloseModal = () => {
    closeModal();
    displaySuccessNotification({
      customJSXMessage: <>No se realizaron cambios en el acuerdo de pago</>
    });
  };

  const currentCommittedPaymentDate =
    formatShortDate(newCommittedPaymentDate || committedPaymentDate, 0)?.onlyDate || committedPaymentDate;

  return (
    <div id="modalUpdateCredit">
      <div className="bgModal" onClick={closeModal}></div>
      <div className="containerModal">
        <CloseIcon className="positionClose" onClick={closeModal} />
        <div className="containerTitle">
          <IconNudos />
          <span>Actualizar acuerdo de pago</span>
        </div>
        <div className="containerSubtitle">{getSubtitleText()}</div>

        <div className="containerConfirmUpdate">
          <div className="infoUpdate">
            <div className="dealing">
              <p>Cliente:</p>
              <p className="dealingValue">{organizationName}</p>
            </div>
            <div className="dealing">
              <p>Plazo anterior:</p>
              <p className="dealingValue">{formatShortDate(committedPaymentDate)?.onlyDate || committedPaymentDate}</p>
            </div>
            <div className="dealing">
              <p>Plazo actualizado:</p>
              <p className="dealingValue">{currentCommittedPaymentDate}</p>
            </div>
          </div>
        </div>

        <CreditDaysCounter
          customClassCreditDaysCounter="customClassCreditDaysCounter"
          days={organizationCreditDays}
          showCreditDaysCounter
          customText="Esta empresa tiene un plazo de acuerdo de pago de"
        />

        <div className="notificationCheckbox">
          <NudosSelectButton
            isButtonActive={sendNotificationEmail}
            handleClickButton={() => setSendNotificationEmail(!sendNotificationEmail)}
            isButtonDisabled={isUpdating}
          />
          <p className="notificationCheckboxText">Enviar notificación por email al cliente</p>
        </div>

        <div className="containerInfoUpdateButtons">
          <div className="containerSubtitle">¿Deseas actualizar el plazo de acuerdo de pago?</div>
          <div className="buttons">
            <NudosButton
              buttonText="Mantener acuerdo actual"
              customClassName="cancelButton"
              handleClick={handleCloseModal}
              isButtonDisabled={isUpdating}
            />
            <NudosButton
              buttonText="Actualizar acuerdo de pago"
              customClassName="updateButton"
              handleClick={() => onUpdateCreditDate(sendNotificationEmail)}
              isButtonDisabled={!newCommittedPaymentDate || isUpdating}
              isButtonLoading={isUpdating}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalUpdateCredit;
